import Question from "./Question";

export { Question };
